/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import * as React from "react"
import MuiThemeProvider from "./src/components/theme-provider"

export const wrapRootElement = ({ element }) => {
  return <MuiThemeProvider>{element}</MuiThemeProvider>
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Scroll to top on route change
  if (prevLocation && location.pathname !== prevLocation.pathname) {
    window.scrollTo(0, 0)
  }
}
